export const LARGE_DESKTOP = 1440
export const DESKTOP = 1280
export const LARGE_TABLET = 1024
export const TABLET = 768
export const SMALL_TABLET = 640
export const MOBILE = 0